import { Module, ConfigModule } from '@produce8/pegasus';
import { DiLogManager } from '../common/port/log/di-log.manager.port';
import { DiCubeAdapter } from '../infrastructure/adapters/cube/di-cube.adapter';
import { OrgWorkingDaysPort } from '../core/application/ports/working-days/org-working-days.port';

@Module({
  imports: [
    ConfigModule.forRoot({
      debug: true,
    }),
  ],
  providers: [DiLogManager, DiCubeAdapter, OrgWorkingDaysPort],
})
export class UserCountValidationModule {}
